import {
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu';

import { SunMoon, Monitor, Sun, Moon } from 'lucide-react';
import { useTranslations } from '@/hooks/useTranslations';

export function ThemeMenu({ setTheme }: { setTheme: (theme: string) => void }) {
  const t = useTranslations('Navigation');

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className="cursor-pointer">
        <SunMoon className="w-4 h-4" color="#787B80" />
        <span className="text-sm font-medium">{t('theme')}</span>
      </DropdownMenuSubTrigger>

      <DropdownMenuPortal>
        <DropdownMenuSubContent>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => setTheme('light')}
          >
            <Sun className="w-4 h-4" color="#787B80" /> {t('light')}
          </DropdownMenuItem>

          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => setTheme('dark')}
          >
            <Moon className="w-4 h-4" color="#787B80" /> {t('dark')}
          </DropdownMenuItem>

          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => setTheme('system')}
          >
            <Monitor className="w-4 h-4" color="#787B80" />
            {t('system')}
          </DropdownMenuItem>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}
